export default __webpack_public_path__ + "static/media/motion_logo_svg.62c76fec.svg";